import { Exception } from '@jewelutions/core-common-domain';

export class OperationsHelper {
  public static retrieveBytesFromGQLResponse(data: any): any {
    if (data === undefined || data === null)
      throw new Exception(`Cannot retrieve bytes from null / undefined data`);
    for (const key of Object.keys(data)) {
      if (data[key]) return data[key];
    }
    return undefined;
  }

  public static retrievePropertyFromGQLResponse(data: any, propertyName: string): any {
    if (data === undefined || data === null)
      throw new Exception(`Cannot extract property ${[propertyName]} from null / undefined data`);
    for (const key of Object.keys(data)) {
      if (data[key][propertyName]) return data[key][propertyName];
    }
    return undefined;
  }
}
